<template>
  <div class="pa-7" id="Example">
    <!--タイトル-->
    <span class="subHead">
    {{ title }}
    </span>
    <v-icon
    class="mb-2"
    color="blue-grey darken-2">
      {{ icon }}
    </v-icon>
    <!--内容-->
<div class="row">
<v-col  cols="12" sm="12" md="4" lg="4" xl="4">
<v-card class="example-card"  height="100%">
  <v-card-text>
    <div class="card-title">Case study</div>
  </v-card-text>
    <v-card-text>
    <div class="card-textcolor">国立大学医学部E-Learningシステムのコンテンツ全文検索</div>
  </v-card-text>
</v-card>
</v-col>
<v-col  cols="12" sm="12" md="4" lg="4" xl="4">
<v-card class="example-card"  height="100%">
  <v-card-text>
    <div class="card-title">Case study</div>
  </v-card-text>
  <v-card-text>
    <div class="card-textcolor">企業向け技術資料全文検索システム</div><br/>
  </v-card-text>
</v-card>
</v-col>
<v-col  cols="12" sm="12" md="4" lg="4" xl="4">
<v-card class="example-card"  height="100%">
  <v-card-text>
    <div class="card-title">Case study</div>
  </v-card-text>
  <v-card-text>
    <div class="card-textcolor">国立大学医学部同窓会会報全文検索システム</div>
  </v-card-text>
</v-card>
</v-col>
</div>
<div style="text-align:center; color:#C62828; margin-top:3rem;">試用など各種ご相談お問い合わせは、こちらからお願いいたします。</div>
  </div>
</template>

<style>
.subHead {
  font-size: 25px;
}

.summary {
  vertical-align: middle;
  font-size: 16px;
}
v-list-item{
  margin-bottom:-8px;
}
.example-card{
  margin:0.2rem;
}
.card-textcolor{
    color:#345fb5;
    font-size:16px;
}
.card-title{
    color:#B0BEC5;
}
</style>

<script>
export default {
  data () {
    return {
      // タイトル
      title: '導入事例',
      // タイトル横のアイコン
      icon: 'mdi-clipboard-text-outline',
      // 説明文
      description: ''
    }
  }
}
</script>
